import { Component, input } from '@angular/core';
import { BaseComponent } from '@app/entities/node/base/base.component';
import { NodeCalcovComponent } from '@app/entities/node/node-calcov/node-calcov.component';
import { NodeCampComponent } from '@app/entities/node/node-camp/node-camp.component';
import { NodeCodetComponent } from '@app/entities/node/node-codet/node-codet.component';
import { NodeCofocComponent } from '@app/entities/node/node-cofoc/node-cofoc.component';
import { NodeCoperComponent } from '@app/entities/node/node-coper/node-coper.component';
import { NodeCosamComponent } from '@app/entities/node/node-cosam/node-cosam.component';
import { NodeCotopComponent } from '@app/entities/node/node-cotop/node-cotop.component';
import { NodeCoverComponent } from '@app/entities/node/node-cover/node-cover.component';
import { NodeCsrproComponent } from '@app/entities/node/node-csrpro/node-csrpro.component';
import { NodeExconComponent } from '@app/entities/node/node-excon/node-excon.component';
import { NodeGaconComponent } from '@app/entities/node/node-gacon/node-gacon.component';
import { NodeGdoverComponent } from '@app/entities/node/node-gdover/node-gdover.component';
import { NodeGeneralAgencyComponent } from '@app/entities/node/node-general-agency/node-general-agency.component';
import { NodeGuideComponent } from '@app/entities/node/node-guide/node-guide.component';
import { NodeHomeComponent } from '@app/entities/node/node-home/node-home.component';
import { NodePersonComponent } from '@app/entities/node/node-person/node-person.component';
import { NodePrComponent } from '@app/entities/node/node-pr/node-pr.component';
import { NodePreoverComponent } from '@app/entities/node/node-preover/node-preover.component';
import { NodeProamComponent } from '@app/entities/node/node-proam/node-proam.component';
import { NodeProcomComponent } from '@app/entities/node/node-procom/node-procom.component';
import { NodeProconComponent } from '@app/entities/node/node-procon/node-procon.component';
import { NodeProcovComponent } from '@app/entities/node/node-procov/node-procov.component';
import { NodeProductComponent } from '@app/entities/node/node-product/node-product.component';
import { NodeProfleComponent } from '@app/entities/node/node-profle/node-profle.component';
import { NodeProserComponent } from '@app/entities/node/node-proser/node-proser.component';
import { NodeProverComponent } from '@app/entities/node/node-prover/node-prover.component';
import { NodeSerconComponent } from '@app/entities/node/node-sercon/node-sercon.component';
import { NodeServiceComponent } from '@app/entities/node/node-service/node-service.component';
import { NodeTopaComponent } from '@app/entities/node/node-topa/node-topa.component';
import { NodeVideomessageComponent } from '@app/entities/node/node-videomessage/node-videomessage.component';
import { NodeProratpaComponent } from '@app/entities/node/node-proratpa/node-proratpa.component';
import { WebformComponent } from '@app/entities/webform/webform/webform.component';

@Component({
  selector: 'mobi-node-loader',
  template: `
    @switch (bundle()) {
      @case ('Webform') {
        <mobi-node-webform [entity]="data().entity" [params]="params()" />
      }
      @case ('NodeCalcov') {
        <mobi-node-calcov [entity]="data().entity" [params]="params()" />
      }
      @case ('NodeCamp') {
        <mobi-node-camp [entity]="data().entity" />
      }
      @case ('NodeCodet') {
        <mobi-node-codet [entity]="data().entity" />
      }
      @case ('NodeCofoc') {
        <mobi-node-cofoc [entity]="data().entity" />
      }
      @case ('NodeCoper') {
        <mobi-node-coper [entity]="data().entity" />
      }
      @case ('NodeCosam') {
        <mobi-node-cosam [entity]="data().entity" />
      }
      @case ('NodeCotop') {
        <mobi-node-cotop [entity]="data().entity" />
      }
      @case ('NodeCover') {
        <mobi-node-cover [entity]="data().entity" />
      }
      @case ('NodeCsrpro') {
        <mobi-node-csrpro [entity]="data().entity" />
      }
      @case ('NodeExcon') {
        <mobi-node-excon [entity]="data().entity" />
      }
      @case ('NodeGacon') {
        <mobi-node-gacon [entity]="data().entity" />
      }
      @case ('NodeGdover') {
        <mobi-node-gdover [entity]="data().entity" />
      }
      @case ('NodeGeneralAgency') {
        <mobi-node-general-agency [entity]="data().entity" />
      }
      @case ('NodeGuide') {
        <mobi-node-guide [entity]="data().entity" />
      }
      @case ('NodeHome') {
        <mobi-node-home [entity]="data().entity" />
      }
      @case ('NodePerson') {
        <mobi-node-person [entity]="data().entity" />
      }
      @case ('NodePr') {
        <mobi-node-pr [entity]="data().entity" />
      }
      @case ('NodePreover') {
        <mobi-node-preover [entity]="data().entity" />
      }
      @case ('NodeProam') {
        <mobi-node-proam [entity]="data().entity" />
      }
      @case ('NodeProcom') {
        <mobi-node-procom [entity]="data().entity" />
      }
      @case ('NodeProcon') {
        <mobi-node-procon [entity]="data().entity" />
      }
      @case ('NodeProcov') {
        <mobi-node-procov [entity]="data().entity" />
      }
      @case ('NodeProduct') {
        <mobi-node-product [entity]="data().entity" />
      }
      @case ('NodeProfle') {
        <mobi-node-profle [entity]="data().entity" />
      }
      @case ('NodeProser') {
        <mobi-node-proser [entity]="data().entity" />
      }
      @case ('NodeProratpa') {
        <mobi-node-proratpa [entity]="data().entity" />
      }
      @case ('NodeProver') {
        <mobi-node-prover [entity]="data().entity" />
      }
      @case ('NodeSercon') {
        <mobi-node-sercon [entity]="data().entity" [params]="params()" />
      }
      @case ('NodeService') {
        <mobi-node-service [entity]="data().entity" />
      }
      @case ('NodeTopa') {
        <mobi-node-topa [entity]="data().entity" />
      }
      @case ('NodeVideomessage') {
        <mobi-node-videomessage [entity]="data().entity" />
      }
      @default {
        <node-base [entity]="data().entity" />
      }
    }
  `,
  standalone: true,
  imports: [
    BaseComponent,
    NodeCalcovComponent,
    NodeCampComponent,
    NodeCodetComponent,
    NodeCofocComponent,
    NodeCoperComponent,
    NodeCosamComponent,
    NodeCotopComponent,
    NodeCoverComponent,
    NodeCsrproComponent,
    NodeExconComponent,
    NodeGaconComponent,
    NodeGdoverComponent,
    NodeGeneralAgencyComponent,
    NodeGuideComponent,
    NodeHomeComponent,
    NodePersonComponent,
    NodePrComponent,
    NodePreoverComponent,
    NodeProamComponent,
    NodeProcomComponent,
    NodeProconComponent,
    NodeProcovComponent,
    NodeProductComponent,
    NodeProfleComponent,
    NodeProratpaComponent,
    NodeProserComponent,
    NodeProverComponent,
    NodeSerconComponent,
    NodeServiceComponent,
    NodeTopaComponent,
    NodeVideomessageComponent,
    WebformComponent,
  ],
})
export class NodeLoaderComponent {
  readonly bundle = input.required<string>();
  readonly data = input<any>({});
  readonly params = input<URLSearchParams>(new URLSearchParams());
}
